<template>
    <div class="search">
        <Row>
            <Col>
                <Card>
                    <Row @keydown.enter.native="handleSearch">
                        <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
                            <Form-item label="订单号" prop="orderSeqNo">
                                <Input type="text" v-model="searchForm.orderSeqNo" placeholder="请输入订单号" clearable style="width: 200px"/>
                            </Form-item>
                            <Form-item label="用户ID" prop="registerId">
                                <Input type="text" v-model="searchForm.registerId" placeholder="请输入用户ID" clearable style="width: 200px"/>
                            </Form-item>
                 <FormItem label="订单状态" prop="orderStatus" >
                  <Select v-model="searchForm.orderStatus">
                    <Option value="wait">待审核</Option>
                        <Option value="identify">审核通过</Option>
                        <Option value="reject_editable">驳回可编辑</Option>
                        <Option value="reject">驳回不可编辑</Option>
                        <Option value="is_sended">审核中</Option>
                        <Option value="identifyWaitSend">已审核,发送中</Option>
                  </Select>
                </FormItem>
                <Form-item label="作品全称" prop="workFullName">
                  <Input type="text" v-model="searchForm.workFullName" placeholder="请输入作品全称" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="提交订单时间" prop="createDate">
                  <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
                </Form-item>
                <Form-item style="margin-left:-35px;" class="br">
                  <Button @click="orderExport" type="primary" icon="ios-search">根据查询条件导出</Button>
                  <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                  <Button @click="handleReset">重置</Button>
                </Form-item>
            </Form>
        </Row>
<!--                    <Row class="operation">
                        <Button @click="getDataList" icon="md-refresh">刷新</Button>
                    </Row>-->
                    <Row>
                        <Alert show-icon>
                            已选择 <span class="select-count">{{selectCount}}</span> 项
                            <a class="select-clear" @click="clearSelectAll">清空</a>
                        </Alert>
                    </Row>
                    <Row>
                        <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
                    </Row>
                    <Row type="flex" justify="end" class="page">
                      <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
                    </Row>
                </Card>
            </Col>
        </Row>
        <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
            <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >
                <FormItem label="自增ID" prop="id" >
                    <Input v-model="form.id" style="width:100%"/>
                </FormItem>-->
                <FormItem label="订单序列号" prop="orderSeqNo" >
                    <Input v-model="form.orderSeqNo" style="width:100%"/>
                </FormItem>
                <FormItem label="登记账号对应ID" prop="registerId" >
                    <Input v-model="form.registerId" style="width:100%"/>
                </FormItem>
                <FormItem label="证书编码" prop="certCode" >
                    <Input v-model="form.certCode" style="width:100%"/>
                </FormItem>
                <FormItem label="发证书时间" prop="cerTime" >
                    <DatePicker type="daterange" v-model="form.cerTime" style="width:100%"></DatePicker>
                </FormItem>
                <FormItem label="证书url" prop="certUrl" >
                    <Input v-model="form.certUrl" style="width:100%"/>
                </FormItem>
                <FormItem label="私有证书url图片" prop="cerImgPrivateUrl" >
                    <Input v-model="form.cerImgPrivateUrl" style="width:100%"/>
                </FormItem>
                <FormItem label="公有证书url图片" prop="cerImgPublicUrl" >
                    <Input v-model="form.cerImgPublicUrl" style="width:100%"/>
                </FormItem>
                <FormItem label="申请类型    vip：VIP存证      common :  非VIP普通存证;    open_api:通过开放平台api的存证" prop="applyType" >
                    <Input v-model="form.applyType" style="width:100%"/>
                </FormItem>
                <FormItem label="订单状态  wait:待审核   identify: 审核通过   cert_sign_issue:证书已签发 reject:驳回不可编辑    reject_editable:驳回可编辑" prop="orderStatus" >
                    <Input v-model="form.orderStatus" style="width:100%"/>
                </FormItem>
                <FormItem label="订单状态中文描述  审核中；登记成功；驳回不可编辑；驳回可编辑" prop="orderStatusCn" >
                    <Input v-model="form.orderStatusCn" style="width:100%"/>
                </FormItem>
                <FormItem label="创作创作性质 1:原创; 2:改编; 3:翻译; 4:汇编 5:注释; 6:整理; 7:其他" prop="creativeType" >
                    <Input v-model="form.creativeType" style="width:100%"/>
                </FormItem>
                <FormItem label="作品全称" prop="workFullName" >
                    <Input v-model="form.workFullName" style="width:100%"/>
                </FormItem>
                <FormItem label="创建时间" prop="createDate" >
                    <DatePicker type="daterange" v-model="form.createDate" style="width:100%"></DatePicker>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" @click="modalVisible=false">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>
            </div>
        </Modal>

        <!---->

        <Drawer width="640" v-model="infoDrawerVisible" title="">
            <div slot="header">
                <Row>
                    <Col>
                        <span v-if="auditOrEdit == 'audit'">版权登记审核</span>
                        <span v-if="auditOrEdit == 'edit'">版权登记详情</span>
                    </Col>
                </Row>
                <Row type="flex" v-if="auditOrEdit == 'audit'" justify="space-around">
                    <Button type="error" :loading="submitLoading" @click="auditOrderSubmit('reject')">审核拒绝(不可)编辑</Button>
                    <Button type="warn" :loading="submitLoading" @click="auditOrderSubmit('reject_editable')">审核拒绝(可)编辑</Button>
                    <Button type="primary" :loading="submitLoading" @click="auditOrderSubmit('identifyWaitSend')">审核通过</Button>
                </Row>
            </div>
            <Form ref="infoForm" :model="infoForm" :label-width="100" :rules="formValidate" >
                <FormItem label="作品全称" prop="orderTitle" >
                    <Input v-model="infoForm.workFullName" style="width:100%"/>
                </FormItem>
                <FormItem label="订单号" prop="orderSeqNo" >
                    <Input v-model="infoForm.orderSeqNo" style="width:100%"/>
                </FormItem>
                <FormItem label="订单状态" prop="orderAuditStatus" >
                    <Select v-model="infoForm.orderStatus">
                        <Option value="wait">待审核</Option>
                        <Option value="identify">审核通过</Option>
                        <Option value="reject_editable">驳回可编辑</Option>
                        <Option value="reject">驳回不可编辑</Option>
                        <Option value="is_sended">审核中</Option>
                        <Option value="identifyWaitSend">已审核,发送中</Option>
                    </Select>
                </FormItem>

                <FormItem label="作品类型" prop="workTypeDesc" >
                    <Input v-model="infoForm.workTypeDesc" style="width:100%"/>
                </FormItem>
                <FormItem label="作者" prop="authorName" >
                    <Input v-model="infoForm.authorName" style="width:100%"/>
                </FormItem>
                <FormItem label="著作权人" prop="powerName" >
                    <Input v-model="infoForm.powerName" style="width:100%"/>
                </FormItem>
                <FormItem label="作品创作性质" prop="creativeType" >
                    <Input v-model="infoForm.creativeType" style="width:100%"/>
                </FormItem>


                <FormItem label="权利归属" prop="copyrightType" >
                    <Input v-model="infoForm.copyrightType" style="width:100%"/>
                </FormItem>
                <FormItem label="创作完成时间" prop="completeDate" >
                    <Input v-model="infoForm.completeDate" style="width:100%"/>
                </FormItem>
                <FormItem label="创作地点" >
                    <Input v-model="infoForm.completeCountry" style="width:30%"/>
                    <Input v-model="infoForm.completeProvince" style="width:30%"/>
                    <Input v-model="infoForm.completeCity" style="width:30%"/>
                </FormItem>

                <FormItem label="发表状态" prop="publishStatus" >
                    <Input v-model="infoForm.publishStatus" style="width:100%"/>
                </FormItem>
                <FormItem label="首次发表时间" prop="publishDate" >
                    <Input v-model="infoForm.publishDate" style="width:100%"/>
                </FormItem>
                <FormItem label="首次发表地点" >
                    <Input v-model="infoForm.publishCountry" style="width:30%"/>
                    <Input v-model="infoForm.publishProvince" style="width:30%"/>
                    <Input v-model="infoForm.publishCity" style="width:30%"/>
                </FormItem>
              <FormItem label="已发表的截图或照片" prop="publishUrl" >
                <Input v-model="infoForm.publishUrl" style="width:100%"/>
              </FormItem>
                <FormItem label="作品文件" prop="attachments">
                    <Input v-model="infoForm.worksAttachments"/>
                </FormItem>
                <FormItem label="权益拥有情况" prop="powerScope">
                    <Input v-model="infoForm.powerScope"/>
                </FormItem>

                <FormItem label="创作意图" prop="creationIntentions">
                    <Input v-model="infoForm.creationIntentions"/>
                </FormItem>

                <FormItem label="作品独创性" prop="creationOriginality">
                    <Input v-model="infoForm.creationOriginality"/>
                </FormItem>


                <FormItem label="其他附件" prop="cerImgPublicUrl">
                    <Input v-model="infoForm.otherAttachments"/>
                </FormItem>
                <FormItem label="订单提交时间" prop="createDate">
                    <Input v-model="infoForm.createDate"/>
                </FormItem>
                <FormItem label="驳回原因" prop="rejectReason">
                    <Input v-model="infoForm.rejectReason"/>
                </FormItem>
                <FormItem label="证书编号" prop="certCode">
                    <Input v-model="infoForm.certCode"/>
                </FormItem>
                <FormItem label="作品登记证书" prop="cerImgPublicUrl">
                    <Input v-model="infoForm.cerImgPublicUrl"/>
                </FormItem>
                <FormItem label="下载证书" prop="certUrl">
                    <a :href="infoForm.certUrl">点击下载</a>
                </FormItem>

            </Form>
        </Drawer>

        <Modal v-model="showRejectModal" title="驳回原因" footer-hide draggable>
            <Row type="flex" justify="space-around">
                <Col span="12">
                    <Input placeholder="拒绝原因" v-model="auditMsg"/>
                </Col>
                <Col offset="4" span="4">
                    <Button type="default" @click="showRejectModal=false">取消</Button>
                </Col>
                <Col span="4">
                    <Button type="primary" :loading="submitLoading" @click="rejectSubmit">提交</Button>
                </Col>
            </Row>
        </Modal>


        <!---->
    </div>
</template>

<script>
    export default {
        name: "CopyrightRegisterOrderDciList",
        components: {
        },
        data() {
            return {
                showRejectModal: false,
                infoDrawerVisible: false,
                loading: true, // 表单加载状态
                modalType: 0, // 添加或编辑标识
                modalVisible: false, // 添加或编辑显示
                modalTitle: "", // 添加或编辑标题
                drop: false,
                dropDownContent: "展开",
                dropDownIcon: "ios-arrow-down",
                searchForm: { // 搜索框初始化对象
                    pageNumber: 1, // 当前页数
                    pageSize: 10, // 页面大小
                    sort: "id", // 默认排序字段
                    order: "desc", // 默认排序方式
                    startDate: "", // 起始时间
                    endDate: "", // 终止时间
                    workFullName: "",
                    orderSeqNo: "",
                    orderStatus: "",
                    registerId: ""
                },
                selectDate: null,
                formDetail: {
                    registerOrder: [],
                    worksExtend: [],
                    worksInstruction: [],
                    worksAttachmentses: {},
                    authors: {},
                    powers: {},
                },
                form: { // 添加或编辑表单对象初始化数据
                    id: "",
                    orderSeqNo: "",
                    registerId: "",
                    certCode: "",
                    cerTime: "",
                    certUrl: "",
                    cerImgPrivateUrl: "",
                    cerImgPublicUrl: "",
                    applyType: "",
                    orderStatus: "",
                    orderStatusCn: "",
                    creativeType: "",
                    workFullName: "",
                    createDate: "",



                    authorName:"",
                    powerName:"",
                    creativeType:"",
                    copyrightType:"",
                    completeDate:"",
                    completeCountry:"",
                    completeProvince:"",
                    completeCity:"",
                    publishStatus:"",
                    publishDate:"",
                    publishCountry:"",
                    publishProvince:"",
                    publishCity:"",
                    worksAttachments:"",
                    powerScope:"",
                    creationIntentions:"",
                    creationOriginality:"",

                    cerImgPublicUrl:"",
                    certCode:"",
                    certUrl:"",



                },
                // 表单验证规则
                formValidate: {
                },
                submitLoading: false, // 添加或编辑提交状态
                selectList: [], // 多选数据
                selectCount: 0, // 多选计数
                columns: [
                    // 表头
                   /* {
                        type: "selection",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "自增ID",
                        key: "id",
                        minWidth: 30,
                        sortable: false,
                    },*/
                    {
                        title: "订单序列号",
                        key: "orderSeqNo",
                        minWidth: 160,
                        sortable: false,
                    },
                    /*{
                        title: "登记账号对应ID",
                        key: "registerId",
                        minWidth: 100,
                        sortable: false,
                    },*/
                    {
                        title: "证书编码",
                        key: "certCode",
                        minWidth: 140,
                        sortable: false,
                    },
                    {
                        title: "审核通过/驳回时间",
                        key: "cerTime",
                        minWidth: 120,
                        sortable: false,
                    },
                    {
                        title: "订单状态",
                        key: "orderStatusCn",
                        minWidth: 120,
                        sortable: false,
                    },
                    {
                        title: "作品全称",
                        key: "workFullName",
                        minWidth: 120,
                        sortable: false,
                    },
                    {
                        title: "提交时间",
                        key: "createDate",
                        minWidth: 120,
                        sortable: false,
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        width: 200,
                        fixed: 'right',
                        render: (h, params) => {
                            return h("div", [
                                params.row.orderStatus == 'wait' || params.row.orderStatus == 'reject_editable' || params.row.orderStatus == 'reject'
                                    ?
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "primary",
                                                size: "small",
                                                icon: "ios-create-outline"
                                            },
                                            style: {
                                                marginRight: "5px"
                                            },
                                            on: {
                                                click: () => {
                                                    this.auditOrder(params.row);
                                                }
                                            }
                                        },
                                        "审核"
                                    ) :
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "info",
                                                size: "small",
                                                icon: "md-trash"
                                            },
                                            on: {
                                                click: () => {
                                                    this.detail(params.row.orderSeqNo);
                                                    // this.edit2(params.row);
                                                }
                                            }
                                        },
                                        "查看"
                                    )
                            ]);
                        }
                    }
                ],
                /*data: [], // 表单数据
                attachColumns: [
                    {
                        title: "附件地址",
                        key: "worksAttachments",
                        minWidth: 120,
                        sortable: false,
                        render(h, params){
                            return h("div", [
                                h(
                                    "A",
                                    {
                                        attrs:{
                                            href: params.row.worksAttachments,
                                            target: '_blank'
                                        },
                                        props: {
                                            type: "info",
                                            size: "small",
                                        },
                                        style: {
                                            marginRight: "5px"
                                        },
                                        // on: {
                                        //   // click: () => {
                                        //   //   //this.auditOrder(params.row);
                                        //   // }
                                        // }
                                    },
                                    params.row.worksAttachments
                                )
                            ]);
                        }
                    }
                ],*/
                // data: [], // 表单数据
                total: 0, // 表单数据总数
                infoForm: {},
                auditFlag: '',
                auditMsg: '',
                auditOrEdit: ''
            };
        },
        methods: {
            init() {
                this.getDataList();
            },
            changePage(v) {
                this.searchForm.pageNumber = v;
                this.getDataList();
                this.clearSelectAll();
            },
            changePageSize(v) {
                this.searchForm.pageSize = v;
                this.getDataList();
            },
            handleSearch() {
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.getDataList();
            },
            orderExport() {
              this.loading = true;
              // 带多条件搜索参数获取表单数据 请自行修改接口
              this.getRequest("/copyrightRegisterDci/export", this.searchForm, 'blob').then(response => {
                this.loading = false;
                var blob = new Blob([response])
                var downloadElement = document.createElement('a');
                var href = window.URL.createObjectURL(blob); //创建下载的链接
                downloadElement.href = href;
                downloadElement.download = '登记订单.xlsx'; //下载后文件名
                document.body.appendChild(downloadElement);
                downloadElement.click(); //点击下载
                document.body.removeChild(downloadElement); //下载完成移除元素
                window.URL.revokeObjectURL(href); //释放掉blob对象

                console.log(response);
              });
            },
            handleReset() {
                this.$refs.searchForm.resetFields();
                this.searchForm.pageNumber = 1;
                this.searchForm.pageSize = 10;
                this.selectDate = null;
                this.searchForm.startDate = "";
                this.searchForm.endDate = "";
                // 重新加载数据
                this.getDataList();
            },
            changeSort(e) {
                this.searchForm.sort = e.key;
                this.searchForm.order = e.order;
                if (e.order === "normal") {
                    this.searchForm.order = "";
                }
                this.getDataList();
            },
            clearSelectAll() {
                this.$refs.table.selectAll(false);
            },
            changeSelect(e) {
                this.selectList = e;
                this.selectCount = e.length;
            },
            selectDateRange(v) {
                if (v) {
                    this.searchForm.startDate = v[0];
                    this.searchForm.endDate = v[1];
                }
            },
            dropDown() {
                if (this.drop) {
                    this.dropDownContent = "展开";
                    this.dropDownIcon = "ios-arrow-down";
                } else {
                    this.dropDownContent = "收起";
                    this.dropDownIcon = "ios-arrow-up";
                }
                this.drop = !this.drop;
            },
            getDataList() {
                this.loading = true;
                // 带多条件搜索参数获取表单数据 请自行修改接口
                this.postRequest("/copyrightRegisterDci/getByPage", this.searchForm).then(res => {
                    this.loading = false;
                    if (res.success) {
                        this.data = res.result.records;
                        this.total = res.result.total;
                    }
                });
            },
            handleSubmit() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        this.submitLoading = true;
                        if (this.modalType === 0) {
                            // 添加 避免编辑后传入id等数据 记得删除
                            delete this.form.id;
                            // this.postRequest("请求地址", this.form).then(res => {
                            //   this.submitLoading = false;
                            //   if (res.success) {
                            //     this.$Message.success("操作成功");
                            //     this.getDataList();
                            //     this.modalVisible = false;
                            //   }
                            // });
                            // 模拟请求成功
                            this.submitLoading = false;
                            this.$Message.success("操作成功");
                            this.getDataList();
                            this.modalVisible = false;
                        } else {
                            // 编辑
                            // this.postRequest("请求地址", this.form).then(res => {
                            //   this.submitLoading = false;
                            //   if (res.success) {
                            //     this.$Message.success("操作成功");
                            //     this.getDataList();
                            //     this.modalVisible = false;
                            //   }
                            // });
                            // 模拟请求成功
                            this.submitLoading = false;
                            this.$Message.success("操作成功");
                            this.getDataList();
                            this.modalVisible = false;
                        }
                    }
                });
            },
            detail(orderSeqNo) {
                this.modalType = 1;
                this.modalTitle = "详情";
                this.getRequest("/copyrightRegisterDci/getDetail?orderSeqNo="+orderSeqNo).then(res => {
                    this.loading = false;
                    if (res.success) {
                        this.infoForm = res.result;
                        this.infoDrawerVisible = true;
                    }
                });
            },
            auditOrder(order){
                this.auditOrEdit = 'audit';
                this.orderSeqNo = order.orderSeqNo;
                this.id = order.id;
                this.getRequest('/copyrightRegisterDci/getDetail?orderSeqNo='+order.orderSeqNo).then(res => {
                    if(res.success){
                        this.infoForm = res.result;
                        this.infoDrawerVisible = true;
                    }
                    console.log("this.infoForm: ", this.infoForm)
                })
            },
            auditOrderSubmit(flag){
                this.auditFlag = flag;
                // this.orderSeqNo = order.orderSeqNo;
                if(flag === 'reject_editable' || flag === 'reject'){
                    this.showRejectModal = true;
                    /*this.actualSubmit({
                        id: this.infoForm.id,
                        zCopyrightRegisterDciIds: this.orderSeqNo + ','+this.infoForm.id+';',
                        orderStatus: this.auditFlag,
                        orderAuditReason: this.auditMsg,
                    });*/
                }else{
                    this.actualSubmit({
                        zCopyrightRegisterDciIds: this.orderSeqNo + ','+this.id+';',
                        orderStatus: this.auditFlag,
                        orderAuditReason: this.auditMsg,
                    });
                }
            },
            rejectSubmit(){
                this.showRejectModal = false;
                this.actualSubmit({
                    id: this.infoForm.id,
                    zCopyrightRegisterDciIds: this.orderSeqNo + ','+this.infoForm.id+';',
                    orderStatus: this.auditFlag,
                    orderAuditReason: this.auditMsg,
                });
            },
            actualSubmit(data){
                this.postRequest('/copyrightRegisterDci/audit', data).then(res => {
                    if(res.code == 200){
                        this.infoDrawerVisible = false;
                        this.getDataList();
                    }
                });
            }/*,
            edit(v) {
                this.modalType = 1;
                this.modalTitle = "编辑";
                this.$refs.form.resetFields();
                // 转换null为""
                for (let attr in v) {
                    if (v[attr] === null) {
                        v[attr] = "";
                    }
                }
                let str = JSON.stringify(v);
                let data = JSON.parse(str);
                this.form = data;
                this.modalVisible = true;
            }*/
        },
        mounted() {
            this.init();
        }
    };
</script>
<style lang="less">
    .search {
        .operation {
            margin-bottom: 2vh;
        }
        .select-count {
            font-size: 13px;
            font-weight: 600;
            color: #40a9ff;
        }
        .select-clear {
            margin-left: 10px;
        }
        .page {
            margin-top: 2vh;
        }
        .drop-down {
            font-size: 13px;
            margin-left: 5px;
        }
    }
</style>